<!-- クーポンコード認証失敗 コードミス -->
<template>
  <ItemDialog ref="CouponCodeFails" image-type="alert">
    <template #content-area>
      <h2>
        {{ $t("MyTicketTicketing.couponCodeFailed.title") }}
      </h2>
      <p class="text-center">
        {{ $t("MyTicketTicketing.couponCodeFailed.description") }}
      </p>
    </template>
    <template #button-area>
      <ItemButton
        label="戻る"
        action-type="btn-primary"
        @clicked="closeDialog"
      />
    </template>
  </ItemDialog>
</template>

<script>
export default {
  name: "DialogCouponCodeFails",
  methods: {
    async openDialog() {
      this.$refs.CouponCodeFails.open();
    },
    async closeDialog() {
      this.$refs.CouponCodeFails.close();
    },
  },
};
</script>
